<template>
  <BaseActionModal
    :title="title"
    :confirmTitle="translatedAction"
    :loading="loading"
    :isDisabled="isDisabled"
    @cancel-click="inputVal.modal = false"
    @hidden="inputVal.modal = false"
    :isOpen="inputVal.modal"
    v-stream:ok-click="onCouponStatusUpdate"
    :okTitle="translatedAction"
    :okVariant="actionButtonVariant"
  >
    <AGCCheckboxGroup
      v-if="inputVal.action === 'BULK_ADD_CATEGORY'"
      v-model="inputVal.tags"
      :options="tagOptions"
      name="分類標籤"
      label="分類標籤"
      sub-label="(可選多項)"
      id="tags"
      :value-field="'id'"
    >
    </AGCCheckboxGroup>
    <AGCCheckboxGroup
      v-if="inputVal.action === 'BULK_ADD_CATEGORY'"
      v-model="inputVal.cmsTags"
      :options="cmsTagOptions"
      name="推薦標籤"
      label="推薦標籤"
      sub-label="(可選多項)"
      id="cms-tags"
      :value-field="'id'"
    >
    </AGCCheckboxGroup>
    <ContentEditor
      v-else
      v-model="inputVal.remarks"
      class="mb-3"
      :toolbar="remarkEditorToolbar"
      required
      :init="init"
    ></ContentEditor>
    <AGCCheckbox v-if="inputVal.action === 'APPROVE'" v-model="inputVal.doNotSendEmail">
      不要寄送電郵通知
    </AGCCheckbox>
  </BaseActionModal>
</template>

<script>
import { Subject } from 'rxjs';
import ContentEditor from '@/components/editor/ContentEditor.vue';
import AGCCheckboxGroup from '@/components/form/AGCCheckboxGroup.vue';
import BaseActionModal from '../BaseActionModal.vue';
import vModelMixin from '../../mixins/v-model';
import AGCCheckbox from '../form/AGCCheckbox.vue';

export default {
  mixins: [vModelMixin],
  props: {
    loading: {
      type: Boolean,
    },
    onCouponStatusUpdate: {
      type: Subject,
    },
    tagOptions: {
      type: Array,
    },
    cmsTagOptions: {
      type: Array,
    },
  },
  data: () => ({
    remarkEditorToolbar: [
      `
      undo redo |
      bold italic underline strikethrough |
      alignleft aligncenter alignright alignjustify |
      bullist numlist outdent indent`,
    ],
    init: {
      quickbars_insert_toolbar: false,
      height: '250',
    },
  }),
  components: {
    ContentEditor,
    AGCCheckboxGroup,
    BaseActionModal,
    AGCCheckbox,
  },
  computed: {
    isDisabled() {
      const {
        remarks, action, tags, cmsTags,
      } = this.inputVal;
      if (this.inputVal.action === 'BULK_ADD_CATEGORY') {
        return !(tags?.length + cmsTags?.length > 0);
      }
      if (this.$route.name === 'EditMerchant') {
        return this.loading || (!remarks && action !== 'ACTIVATE');
      }
      return action !== 'REMOVE' && (this.loading || !remarks);
    },
    title() {
      if (this.inputVal.action === 'BULK_ADD_CATEGORY') {
        return '選擇分類標籤';
      }
      return `確定${this.translatedAction}此${
        this.$route.name === 'EditMerchant' ? '商戶' : '優惠券'
      }？`;
    },
    translatedAction() {
      switch (this.inputVal.action) {
        case 'APPROVE':
        case 'ACTIVATE':
          return '批准';
        case 'REJECT':
          return '拒絕';
        case 'UNPUBLISH':
          return '暫停發佈';
        case 'DEACTIVATE':
          return '停用';
        case 'REMOVE':
          return '移除';
        default:
          return '確定';
      }
    },
    actionButtonVariant() {
      switch (this.inputVal.action) {
        case 'REJECT':
        case 'UNPUBLISH':
          return 'danger';
        case 'DEACTIVATE':
          return 'danger';
        case 'REMOVE':
          return 'secondary';
        default:
          return 'success';
      }
    },
  },
};
</script>
